import React from 'react';
import DegreeList from '../DegreeList/DegreeList';
import Chevron from '../Chevron/Chevron';
import Spinner from '../Spinner/Spinner';
import './Organization.css';

const Organization = ({
  organization,
  handleOrganizationClick,
  handleDegreeClick,
  handleTermClick,
  loading,
  index
}) => (
  <div className={`Organization--container ${organization.degreesShown ? 'open' : 'closed'}`}>
    <div 
      role="button" 
      className="Organization--bar" 
      onClick={() => handleOrganizationClick(index)}
      tabIndex={0}
      aria-expanded={organization.degreesShown}
      aria-controls={`org-content-${index}`}
    >
      <div className="Organization--name">
        <span>{organization.name}</span>
      </div>
      <div className="Organization--location">{organization.location}</div>
      {loading && <Spinner />}
      {!loading && <Chevron status={`${organization.degreesShown ? 'open' : 'closed'}`} />}
    </div>
    {organization.degreesShown && (
      <div id={`org-content-${index}`}>
        <DegreeList
          organizationIndex={index}
          degrees={organization.degrees}
          handleDegreeClick={handleDegreeClick}
          handleTermClick={handleTermClick}
          organizationId={organization.id}
          website={organization.website}
        />
      </div>
    )}
  </div>
);

export default Organization;
